__turbopack_context__.v({
  "backButton": "CheckoutProgressStepper-module__yLWjyG__backButton",
  "breadcrumbEllipsis": "CheckoutProgressStepper-module__yLWjyG__breadcrumbEllipsis",
  "breadcrumbGroup": "CheckoutProgressStepper-module__yLWjyG__breadcrumbGroup",
  "breadcrumbSeparator": "CheckoutProgressStepper-module__yLWjyG__breadcrumbSeparator",
  "frame": "CheckoutProgressStepper-module__yLWjyG__frame",
  "label_completed": "CheckoutProgressStepper-module__yLWjyG__label_completed",
  "label_current": "CheckoutProgressStepper-module__yLWjyG__label_current",
  "label_pending": "CheckoutProgressStepper-module__yLWjyG__label_pending",
  "progressBarSegments": "CheckoutProgressStepper-module__yLWjyG__progressBarSegments",
  "progressSegment": "CheckoutProgressStepper-module__yLWjyG__progressSegment",
  "progressSegmentFill": "CheckoutProgressStepper-module__yLWjyG__progressSegmentFill",
  "step-segment-fill": "CheckoutProgressStepper-module__yLWjyG__step-segment-fill",
  "stepItem": "CheckoutProgressStepper-module__yLWjyG__stepItem",
  "stepLink": "CheckoutProgressStepper-module__yLWjyG__stepLink" + " " + "CheckoutProgressStepper-module__yLWjyG__label_completed",
  "stepList": "CheckoutProgressStepper-module__yLWjyG__stepList",
  "stepListBreadcrumbSm": "CheckoutProgressStepper-module__yLWjyG__stepListBreadcrumbSm",
  "stepListBreadcrumbXs": "CheckoutProgressStepper-module__yLWjyG__stepListBreadcrumbXs",
  "stepMarker": "CheckoutProgressStepper-module__yLWjyG__stepMarker",
  "topRow": "CheckoutProgressStepper-module__yLWjyG__topRow",
});
